import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from 'context';
import { RETURN_URL_KEY } from 'app/components/routes';

export default function PrivateRoute() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    sessionStorage.setItem(RETURN_URL_KEY, location.pathname + location.search);
    return <Navigate to="/login" />;
  }

  return <Outlet />;
}
